<template>
    <div class="guest-consent" v-if="cookieConsent && !userSignedIn">
        <span>
            {{ myResources.cookieConsent }}:
        </span>
        <span class="guest-consent__analytics">
            <a href="#" @click="toggleCookieConsentData('analytics')" class="guest-consent__analytics__link">{{ displayAcceptedOrWithdrawn(cookieConsent.analytics) }}</a>
        </span>
    </div>
</template>
<script>

import Vuex from 'vuex'

import CookieConsentManager from '@/cookie-consent-manager'
import ResourcesHelper from '@/components/resources-helper'

export default {
    mixins: [
        ResourcesHelper,
    ],

    data() {
        return {
            /**
             * @type {CookieConsent}
             */
            cookieConsent: null,
        }
    },

    computed: {
        ...Vuex.mapGetters([
            'userSignedIn',
        ]),

        /**
         * @returns {AppCoreGuestConsentResources}
         */
        myResources() {
            return this.parseResources('components.appCore.guestConsent')
        },
    },

    async mounted() {
        await this._loadCookieConsent()

        this.$eventbus.$on(this.$appevents.reloadCookieConsent, async() => {
            await this._loadCookieConsent()
        })
    },

    methods: {
        /**
         * Load cookie consent data from storage.
         */
        async _loadCookieConsent() {
            this.cookieConsent = await CookieConsentManager.getConsentDataAsync()
        },

        /**
         * Returns the actionGranted text if state is true, otherwise actionWithdrawn
         * @param {boolean} state
         * @returns {string}
         */
        displayAcceptedOrWithdrawn(state) {
            return state ? this.myResources.actionAccepted : this.myResources.actionWithdrawn
        },

        /**
         * @async
         * @param {string} field
         */
        async toggleCookieConsentData(field) {
            this.cookieConsent[field] = !this.cookieConsent[field]

            await CookieConsentManager.setConsentDataAsync(this.cookieConsent)
        },
    },
}

</script>
<style lang="scss">

.guest-consent {
    display: flex;
    gap: $base-gutter;
    justify-content: flex-end;
}

</style>
